<div class="side-menu v-row">
  <div class="user-info">
    <a class="user-link" routerLink="/dashboard/profile">
      <div class="profile-image">
        <span>
          <img class="center img-responsive" src="{{ currentUser?.avatarUrl || 'assets/images/default-profile-pic-plus.png' }}" alt=""
        /></span>
      </div>
      <span>
        {{ currentUser?.firstName.toLowerCase() }} {{ currentUser?.lastName.toLowerCase() }}<br />
        <small>{{ (currentUser?.nic && currentUser?.nic) || currentUser?.passport }}</small></span
      >
    </a>
  </div>
  <ul class="p-0">
    <li [routerLinkActive]="['active-route']" [routerLinkActiveOptions]="{ exact: true }">
      <a routerLink="/dashboard" [queryParams]="{ uid: currentUser?.id }">
        <i class="icon-home-1 icon-lg"></i>
        <span class="no-tooltip">Home</span>
      </a>
    </li>
    <li [routerLinkActive]="['active-route']" [routerLinkActiveOptions]="{ exact: true }">
      <a routerLink="/super-admin/portal-users" [queryParams]="{ uid: currentUser?.id }">
        <i class="icon-user icon-lg"></i>
        <span class="no-tooltip">Portal users</span>
      </a>
    </li>
    <li [routerLinkActive]="['active-route']" [routerLinkActiveOptions]="{ exact: true }" *ngIf="isSuperAdmin">
      <a routerLink="/super-admin/user-management/previleges-list" [queryParams]="{ uid: currentUser?.id }">
        <i class="icon-user icon-lg"></i>
        <span class="no-tooltip">User management</span>
      </a>
    </li>
    <li [routerLinkActive]="['active-route']" [routerLinkActiveOptions]="{ exact: true }">
      <a routerLink="/super-admin/manage-prd-signup" [queryParams]="{ uid: currentUser?.id }">
        <i class="icon-lg icon-clipboard-edit"></i>
        <span class="no-tooltip">Product signup</span>
      </a>
    </li>

    <li [routerLinkActive]="['active-route']">
      <a routerLink="/login"> <img alt="logout" src="/assets/images/icons/logout.svg" /> &nbsp;<span>Logout</span> </a>
    </li>
  </ul>
</div>
